// @flow
/**
 * User: Mike Chung
 * Date: 6/1/2018
 * Time: 8:32 PM
 */

import React from 'react';
import {Field} from "redux-form";
import {FormGroup, Label} from "reactstrap";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

const renderDatePicker = ({
                              input,
                              label,
                              className,
                              meta: {touched, error, warning},
                              ...rest
                          }) => {
        if (touched && warning) {
            className += " is-invalid";
        }
        const {name, onChange, onBlur, value, ...inputRest} = input;
    let inputProps = {name, ...rest, readOnly: true, autoComplete: 'off'};
    return (
            <FormGroup>
                {label &&
                <Label for={input.id}>{label}</Label>
                }
                <Datetime value={value} closeOnSelect dateFormat={"YYYY-MM-DD"} timeFormat={"HH:mm:ss"} onChange={(moment) => {
                    onChange(typeof moment === 'string' ? moment : moment.format("YYYY-MM-DD HH:mm:ss"));
                }} className={className} {...inputRest} inputProps={inputProps}/>
                <div style={{display: touched && warning ? "block" : "none"}} className={"invalid-feedback"}>{warning}</div>
            </FormGroup>
        )
    }

;
export default function ReduxFormDatepicker(props: any) {

    return (
        <Field component={renderDatePicker} {...props} />
    );
}


// WEBPACK FOOTER //
// ./src/components/form/ReduxFormDatepicker.js